import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import ReleasesTab from './tabs/ReleasesTab';
import VideosTab from './tabs/VideosTab';
import AboutTab from './tabs/AboutTab';
import SubscribersTab from './tabs/SubscribersTab';
import './AdminDashboard.css';

const tabs = [
  { key: 'releases', label: 'Music' },
  { key: 'videos', label: 'Videos' },
  { key: 'about', label: 'About' },
  { key: 'subscribers', label: 'Subscribers' },
];

export default function AdminDashboard() {
  const [active, setActive] = useState('releases');
  const { session, signOut } = useAuth();

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="admin-header-left">
          <span className="admin-brand">2gs Like Gucci</span>
          <span className="admin-brand-sub">Admin</span>
        </div>
        <div className="admin-header-right">
          <span className="admin-user-email">{session?.user?.email}</span>
          <button className="admin-logout-btn" onClick={signOut}>Log out</button>
        </div>
      </header>

      <div className="admin-body">
        <nav className="admin-tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              className={`admin-tab ${active === t.key ? 'active' : ''}`}
              onClick={() => setActive(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>

        <main className="admin-content">
          {active === 'releases' && <ReleasesTab />}
          {active === 'videos' && <VideosTab />}
          {active === 'about' && <AboutTab />}
          {active === 'subscribers' && <SubscribersTab />}
        </main>
      </div>
    </div>
  );
}
